import { ILocation, PlotFacingTypeEnum, PlotOwnerTypeEnum, PlotTypeEnum, PropertyAvailabilityStatusEnum } from 'pages/PropertyListing/types';
import { PlotSizeUnitTypeEnum } from 'pages/ServiceOrder/types';

export interface IPlotForSale {
  _id: string;
  assetNo: string;
  address: string;
  name: string;
  plotNo: string;
  location: ILocation;
  pricePerSqft: string;
  plotSize: string;
  plotType: PlotTypeEnum;
  ventureName: string;
  builderName: string;
  approvals: string[];
  approvalStatus: PlotAdminApprovalStatusEnum;
  createdAt: string;
  updatedAt: string;
  plotSizeUnit: PlotSizeUnitTypeEnum;
  plotWidth: string;
  plotLength: string;
  additionalInfo: string;
  isActive: boolean;
  images: string[];
  availabilityStatus: PropertyAvailabilityStatusEnum;
  plotFacing: PlotFacingTypeEnum;
  locationHighlights: string;
  plotSeller:PlotOwnerTypeEnum
}
export enum PlotAdminApprovalStatusEnum {
  PENDING = 1,
  APPROVED = 2
}

export enum StatusFilterEnum {
  ALL = 0,
  OPEN = 1,
  CLOSE = 2,
  PENDING = 3
}
export interface PlotForSaleState {
  List: IPlotForSale[];
  form: IPlotForSale;
  loading: boolean;
  buttonLoading: boolean;
  search: string;
  pageNo: number;
  pageSize: number;
  totalRow: number;
  orderBy: string;
  orderDir: string;
  endDate: string | null;
  startDate: string | null;
  status: StatusFilterEnum;
}

export type InitialState = PlotForSaleState;
